/*eslint-disable*/ import React from "react";
// @material-ui/core components
import { makeStyles } from "tss-react/mui";
import { Link } from "react-router-dom";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import landingPageStyle from "assets/jss/xrs/views/landingPageStyle.js";
import Paper from "@mui/material/Paper";

const useStyles = makeStyles()(() => landingPageStyle);

export default function LinksSection({ ...rest }) {
  const { classes, cx } = useStyles();
  return (
    <div className={cx(classes.main, classes.mainRaised, classes.paper)}>
      <div className={classes.container}>
        <GridContainer
          direction="row"
          justify="space-evenly"
          alignItems="stretch"
        >
          <GridItem xs={12} sm={6} md={4}>
            <Link to="/quickpay-page">
              <Button className={classes.linkButton} round color="primary">
                <img
                  src={require("../../../assets/img/ico-quick-pay.png")}
                  alt="..."
                  height="45"
                />
              </Button>
            </Link>

            <h4 className={cx(classes.textCenter)}>Quick Pay</h4>
          </GridItem>

          <GridItem xs={12} sm={6} md={4}>
            <Link to="/createUser">
              <Button className={classes.linkButton} round color="primary">
                <img
                  src={require("../../../assets/img/ico-register.png")}
                  alt="..."
                  height="45"
                  className={classes.img}
                />
              </Button>
            </Link>

            <h4 className={cx(classes.textCenter)}>Register</h4>
          </GridItem>

          <GridItem xs={12} sm={6} md={4}>
            <Link to="/faq-page">
              <Button className={classes.linkButton} round color="primary">
                <img
                  src={require("../../../assets/img/ico-faq.png")}
                  alt="..."
                  height="45"
                  className={classes.img}
                />
              </Button>
            </Link>
            <h4 className={cx(classes.textCenter)}>
              Frequently Asked Questions
            </h4>
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
}
